import { useNode } from "@craftjs/core";
import { BasicCarouselPreviewComponent } from "./BasicCarouselPreviewComponent";
import { BasicCarouselSettings } from "./BasicCarouselSettings";

interface BasicCarouselBuilderComponentProps {
  title: string;
  categoryIDs?: string[];
  eventStatus?: string;
  keywords?: string[];
  startDate?: Date | null;
  endDate?: Date | null;
  showSeeMore?: boolean;
  // New props for persistent mode
  isPersistent?: boolean;
  isMostWatched?: boolean;
  persistentStreams?: any[]; // adjust the type as needed
}

const BasicCarouselBuilderComponent = (props: BasicCarouselBuilderComponentProps) => {
  const {
    connectors: { connect, drag },
  } = useNode();

  return (
    <BasicCarouselPreviewComponent
      {...props}
      connect={connect}
      drag={drag}
    />
  );
};

export default BasicCarouselBuilderComponent;

BasicCarouselBuilderComponent.craft = {
  props: {
    title: "Video Carousel",
    categoryIDs: [],
    eventStatus: "published",
    keywords: [],
    // go one year back
    startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
    endDate: null,
    showSeeMore: true,
    isPersistent: false, // default to non-persistent mode
    isMostWatched: false,
    persistentStreams: []  // default empty array
  },
  related: {
    settings: BasicCarouselSettings,
  },
  displayName: "Video Carousel",
};
